"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var lodash_1 = require("lodash");
var VERY_LOW_DISCOUNT_PERCENT = 35;
var HIGH_DISCOUNT_PERCENT = 0;
var RECOMMENDED_DISCOUNT_A = 10;
var RECOMMENDED_DISCOUNT_B = 15;
var DEBOUNCE_DELAY = 800;
var OffersNudgeV2 = /** @class */ (function (_super) {
    tslib_1.__extends(OffersNudgeV2, _super);
    function OffersNudgeV2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            offerTip: '',
        };
        _this.debouncedUpdate = lodash_1.debounce(_this.setOfferTip, DEBOUNCE_DELAY);
        return _this;
    }
    OffersNudgeV2.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.offer.price !== prevProps.offer.price) {
            this.debouncedUpdate();
        }
    };
    OffersNudgeV2.prototype.componentWillUnmount = function () {
        this.debouncedUpdate.flush();
    };
    Object.defineProperty(OffersNudgeV2.prototype, "showOfferTip", {
        get: function () {
            return this.props.offer.price !== '' && this.state.offerTip !== '';
        },
        enumerable: true,
        configurable: true
    });
    OffersNudgeV2.prototype.setOfferTip = function () {
        var offerTip = this.getOfferTip();
        this.setState({ offerTip: offerTip });
    };
    OffersNudgeV2.prototype.getOfferTip = function () {
        if (this.props.offer.price === '') {
            return '';
        }
        var originalPrice = parseFloat(this.props.originalPrice);
        var offerPrice = parseFloat(this.props.offer.price);
        var percentOff = Math.round((1 - (offerPrice / originalPrice)) * 100);
        if (percentOff >= VERY_LOW_DISCOUNT_PERCENT) {
            return I18n.t('commons.offers.offerTipLowball');
        }
        if (percentOff < HIGH_DISCOUNT_PERCENT) {
            return I18n.t('commons.offers.offerTipHighball');
        }
        return '';
    };
    OffersNudgeV2.prototype.getDiscountedPrice = function (discount) {
        var amount = parseFloat(this.props.originalPrice);
        return Math.round(amount * ((100 - discount) / 100)).toString();
    };
    OffersNudgeV2.prototype.handleClick = function (e, discount) {
        e.preventDefault();
        var price = this.getDiscountedPrice(discount);
        this.props.onOfferChange(tslib_1.__assign(tslib_1.__assign({}, this.props.offer), { price: price }));
    };
    OffersNudgeV2.prototype.renderOfferTip = function () {
        if (!this.showOfferTip) {
            return null;
        }
        return (React.createElement("div", { className: "mb-1 weight-bold align-left icon-l-exclamation-circle" }, this.state.offerTip));
    };
    OffersNudgeV2.prototype.renderRecommendationButton = function (discount) {
        var _this = this;
        var classes = classNames('button button--small mlr-half mtb-half fx-grow', { 'button--blue': this.props.offer.price === this.getDiscountedPrice(discount) });
        return (React.createElement("button", { className: classes, onClick: function (e) { return _this.handleClick(e, discount); } }, I18n.t('commons.offers.percentOff', { percent: discount })));
    };
    OffersNudgeV2.prototype.render = function () {
        var classes = classNames('feature-nudge scaling-mb-2', { 'feature-nudge--orange': this.showOfferTip });
        return (React.createElement("div", { className: classes },
            this.renderOfferTip(),
            React.createElement("div", { className: "d-flex fx-align-center mobile-d-block" },
                React.createElement("div", { className: "mobile-mb-half mr-1 align-left" }, I18n.t('commons.offers.recommendedOffers')),
                React.createElement("div", { className: "d-flex fx-wrap fx-grow", style: { margin: '-0.5rem' } },
                    this.renderRecommendationButton(RECOMMENDED_DISCOUNT_A),
                    this.renderRecommendationButton(RECOMMENDED_DISCOUNT_B)))));
    };
    return OffersNudgeV2;
}(React.Component));
exports.default = OffersNudgeV2;
//# sourceMappingURL=offers_nudge_v2.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offers_nudge_v2.js
// module id = 4YRP
// module chunks = 20 21